import { BaseTextMergeContainerEditor } from "../Text/BaseTextMergeContainerEditor";
import { TextIcon } from "../../../CommonUI/TextIcon";
import React, { ReactNode } from "react";
import { XMLAttributeElement } from "../../../rule-engine-core/TextMerge/Elements/JSONXML/XMLAttributeElement";
import { TextMergeEditContext } from "../../../rule-engine-core/TextMerge/TextMergeEditContext";
import { BaseJSONXMLElement } from "../../../rule-engine-core/TextMerge/Elements/JSONXML/BaseJSONXMLElement";
import { UIStyleConstants } from "../../../rule-engine-core/Common/UIStyleConstants";
import { ObserveState } from "../../../CommonUI/StateManagement/ObserveState";
import { BaseTextMergeContainerElement } from "../../../rule-engine-core/TextMerge/Elements/BaseTextMergeContainerElement";
import { TextEditorRegistration } from "../../Utilities/RegisterTextEditor";
import { DataUtilities } from "../../../rule-engine-core/Common/DataUtilities";

export class XMLAttributeEditor extends BaseTextMergeContainerEditor<XMLAttributeElement> {
    static renderXMLContainer(
        element: BaseTextMergeContainerElement,
        editContext: TextMergeEditContext,
        elementName: string,
    ): ReactNode {
        let fields = element.elements.filter((e) => {
            return e.__type !== "xmlattribute";
        });
        let attributes = element.elements.filter((e) => {
            return e.__type === "xmlattribute";
        });

        return (
            <>
                <span
                    style={
                        editContext.selectedElement?.id === element.id
                            ? { background: UIStyleConstants.BLUE_LIGHT_COLOR }
                            : {}
                    }
                    onClick={() => {
                        editContext.setSelectedElement(element!);
                    }}
                >
                    {DataUtilities.getIndent(element.getDepth())}
                    {"<" + elementName + " "}
                </span>
                {attributes.map((e) => {
                    let editor = TextEditorRegistration.getExpressionByTypeName(e.__type)?.create(e);
                    return (
                        <ObserveState
                            key={e.id}
                            listenTo={e}
                            control={() => {
                                return <>{editor?.renderDisplay(e, editContext)} </>;
                            }}
                        />
                    );
                })}

                <span
                    style={
                        editContext.selectedElement?.id === element.id
                            ? { background: UIStyleConstants.BLUE_LIGHT_COLOR }
                            : {}
                    }
                    onClick={() => {
                        editContext.setSelectedElement(element!);
                    }}
                >
                    {">"}
                </span>
                <br />
                {fields.map((e) => {
                    let editor = TextEditorRegistration.getExpressionByTypeName(e.__type)?.create(e);
                    return (
                        <ObserveState
                            key={e.id}
                            listenTo={e}
                            control={() => {
                                return editor?.renderDisplay(e, editContext);
                            }}
                        />
                    );
                })}
                <span
                    style={
                        editContext.selectedElement?.id === element.id
                            ? { background: UIStyleConstants.BLUE_LIGHT_COLOR }
                            : {}
                    }
                    onClick={() => {
                        editContext.setSelectedElement(element!);
                    }}
                >
                    {DataUtilities.getIndent(element.getDepth())}
                    {"</" + elementName + ">\n"}
                </span>
            </>
        );
    }

    getIcon(): JSX.Element {
        return <TextIcon name={"att"} />;
    }

    override renderContent(editContext: TextMergeEditContext, _styles: object): React.ReactNode {
        let output: any[] = [];

        for (let e of this.editorData!.elements) {
            let xe = e as BaseJSONXMLElement;
            if (xe) {
                output.push(
                    <ObserveState
                        listenTo={xe}
                        control={() => {
                            return (
                                <>
                                    <span
                                        style={
                                            editContext.selectedElement?.id === xe.id
                                                ? { background: UIStyleConstants.BLUE_LIGHT_COLOR }
                                                : {}
                                        }
                                        onClick={() => {
                                            editContext.setSelectedElement(e);
                                        }}
                                    >
                                        {xe.fieldName + '="[!field!]" '}
                                    </span>
                                </>
                            );
                        }}
                    />,
                );
            }
        }

        return <>{output}</>;
    }
}
